<template>
  <swiper :options="swiperOption">
    <swiper-slide class="swiperL" v-for="(item, index) in list" :key="index">
      <img :src="item.banner_img" :alt="item.banner_name">
    </swiper-slide>
    <div class="swiper-pagination swiperHH" v-show="list.length>1" v-if="Dtype == 'heng'" slot="pagination"></div>
    <div class="swiper-pagination" v-show="list.length>1" v-else slot="pagination"></div>
  </swiper>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    list: Array,
    Dtype: String
  },
  data () {
    return {
      swiperOption: {
        pagination: '.swiper-pagination',
        loop: false,
        autoplay: 2000
      }
    }
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
img
  width 100%
  height auto
  object-fit contain
.swiperL
  width 100%
  position relative
.swiperHH
  /deep/ .swiper-pagination-bullet
    width px(50)
    height px(8)
    border-radius px(4)
    background rgba(255,255,255,.4)
  /deep/ .swiper-pagination-bullet-active
    background rgba(255,255,255,.8)
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue